import { useCallback } from "react";

import usePlannerV2TravelGroupAddVisit from "./usePlannerV2TravelGroupAddVisit";
import usePlannerV2TravelGroupRemoveVisit from "./usePlannerV2TravelGroupRemoveVisit";

export function usePlannerV2RouteAreaActions({
    travelGroupId,
    allowIfUnavailable = false,
    onSuccess,
}: {
    travelGroupId: string;
    allowIfUnavailable: boolean;
    onSuccess: (plannerTravelGroupId: string) => void;
}) {
    const { addVisit, loading: isLoadingToAddVisit, error: addVisitError } = usePlannerV2TravelGroupAddVisit(onSuccess);

    const {
        removeVisit,
        loading: isLoadingToRemove,
        loadingToRemoveVisitId,
        error: removeError,
    } = usePlannerV2TravelGroupRemoveVisit(onSuccess);

    const addVisitToTravelGroup = useCallback(
        async (timeslotId: string, visitId: string) => {
            await addVisit({
                allowIfUnavailable,
                plannerTravelGroupId: travelGroupId,
                plannerVisitId: visitId,
                timeslotId: timeslotId,
            });
        },
        [addVisit, allowIfUnavailable, travelGroupId],
    );

    const removeVisitFromTravelGroup = useCallback(
        async (visitId: string) => {
            await removeVisit({
                plannerTravelGroupId: travelGroupId,
                plannerVisitId: visitId,
            });
        },
        [removeVisit, travelGroupId],
    );

    return {
        addVisitToTravelGroup,
        removeVisitFromTravelGroup,

        loading: isLoadingToAddVisit || isLoadingToRemove,
        loadingToRemoveVisitId,
        error: addVisitError || removeError,
    };
}
